<template>
  <div class="condition">
    <Condition v-if="Array.isArray(condition[0])" @delete-level="delete0" :condition.sync="condition[0]" />
    <input v-else v-model="condition[0]" type="text">
    <select v-model="condition[1]">
      <option value="==">==</option>
      <option value=">">&gt;</option>
      <option value="<">&lt;</option>
      <option value=">=">&gt;=</option>
      <option value="<">&lt;=</option>
      <option value="&&">&amp;&amp;</option>
      <option value="||">||</option>
      <option value="includes">includes</option>
      <option value="includedIn">includedIn</option>
      <option value="notIncludes">notIncludes</option>
      <option value="notIncludedIn">notIncludedIn</option>
    </select>
    <Condition v-if="Array.isArray(condition[2])" @delete-level="delete2" :condition.sync="condition[2]" />
    <input  v-else v-model="val" :class="{bold: bold}" type="text" >
    <button @click="addCondition">+</button>
    <button v-if="!first" @click="$emit('delete-level')">X</button>
  </div>
</template>

<script>


export default {
    name: 'Condition',
    components: {
      Condition: this
    },
    props: {
      condition: {
        type: Array,
        default(){
          return [null,null,null]
        }
      },
      first: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return{
        verified: true,
        bold: false
      }
    },
    methods: {
      delete0(){
        this.$set(this.condition, 0, this.condition[2][0])
        this.$set(this.condition, 1, this.condition[2][1])
        this.$set(this.condition, 2, this.condition[2][2])
        this.$emit('update:condition', this.condition[2])
      },
      delete2(){
        this.$set(this.condition, 0, this.condition[0][0])
        this.$set(this.condition, 1, this.condition[0][1])
        this.$set(this.condition, 2, this.condition[0][2])
        this.$emit('update:condition', this.condition[0])
      },
      addCondition(){
        let condCache = [this.condition[0],this.condition[1],this.condition[2]]
        this.$set(this.condition, 0,condCache)
        this.$set(this.condition, 1,'&&')
        this.$set(this.condition, 2,[null,null,null])
        this.$emit('update:condition', this.condition)
        
      }
    },
    computed: {
      val: {
        get(){
          // eslint-disable-next-line
          this.bold = false
          if(typeof this.condition[2] == 'string'){
            return this.condition[2]
          }
          if(typeof this.condition[2] == 'number'){
            // eslint-disable-next-line
            this.bold = true
            return this.condition[2]
          }
          if(typeof this.condition[2] == 'boolean'){
            // eslint-disable-next-line
            this.bold = true
            return this.condition[2]? 'true' : 'false'
          }
          if(typeof this.condition[2] == 'undefined'){
            // eslint-disable-next-line
            this.bold = true
            return 'undefined'
          }
          
          return this.condition[2]
          
        },
        set(val){
          //console.log(val)
          // eslint-disable-next-line
          //this.verified = true
          if(!isNaN(parseFloat(val))){
            // eslint-disable-next-line
            this.bold = true
            this.$set(this.condition, 2, parseFloat(val))
          }else if(val == "true"){
            // eslint-disable-next-line
            this.bold = true
            this.$set(this.condition, 2,true)
          }else if(val == "false"){
            // eslint-disable-next-line
            this.bold = true
            this.$set(this.condition, 2,false)
          }else if(val == "undefined"){
            // eslint-disable-next-line
            this.bold = true
            this.$set(this.condition, 2,undefined)
          }else if(/^"[^"]*"$/g.test(this.condition[2])){
            // eslint-disable-next-line
            this.bold = false
            console.log(this.condition)
            this.$set(this.condition, 2,val.replace(/^"|"$/g, '') )
          }else{
            // eslint-disable-next-line
            this.bold = false
            this.$set(this.condition, 2,val.replace(/^"|"$/g, ''))
            // eslint-disable-next-line
            //this.verified = false
          }
          
        }
      }
    }
}
</script>

<style>
.bold{
  font-weight: bold;
  color: blue;
}

.condition{
  display: block;
  border: 2px solid black;
  padding: 8px;
  margin: 16px 8px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  background-color: rgba(0,0,0,0.3);
}
.condition .condition{
  width: 100%;
  
}
</style>